import React, { useState, useEffect } from "react";
import { Table, Button, Card, Col, Row } from "react-bootstrap";
import {fetchAdminFinanceHistory, getAdminSystemHistory} from "../../http/userLogAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ResponsiveBump } from "@nivo/bump";

const AdminFinanceTable = () => {
    const [financeData, setFinanceData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Функция загрузки данных
    const loadFinanceData = async () => {
        setLoading(true);
        try {
            const data = await getAdminSystemHistory();
            if (!Array.isArray(data) || data.length === 0) {
                toast.warning("No data available for the last 30 days", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setFinanceData([]);
                setChartData([]);
            } else {
                toast.success("Finance data loaded", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setFinanceData(data.reverse()); // Дата от новых к старым

                // Формируем данные для графика
                const formattedChartData = [
                    {
                        id: "Balance Sum",
                        data: data.map((item) => ({
                            x: item.date,
                            y: item.totalUsersBalance !== undefined ? item.totalUsersBalance : 0,
                        })),
                    },
                    {
                        id: "Virt Mass",
                        data: data.map((item) => ({
                            x: item.date,
                            y: item.totalVirtsMass !== undefined ? item.totalVirtsMass : 0,
                        })),
                    },
                    {
                        id: "Freeze in Assign's",
                        data: data.map((item) => ({
                            x: item.date,
                            y: item.totalAssignmentsPostedToday !== undefined ? item.totalAssignmentsPostedToday : 0,
                        })),
                    },
                    {
                        id: "Assign's Taken",
                        data: data.map((item) => ({
                            x: item.date,
                            y: item.totalAssignmentsTakenToday !== undefined ? item.totalAssignmentsTakenToday : 0,
                        })),
                    },
                    {
                        id: "Utilisation",
                        data: data.map((item) => ({
                            x: item.date,
                            y: item.totalBookTypePriceShift?.total_shift !== undefined ? item.totalBookTypePriceShift?.total_shift : 0,
                        })),
                    },
                    {
                        id: "Add by New Reg's",
                        data: data.map((item) => ({
                            x: item.date,
                            y: item.newUserDeposits !== undefined ? item.newUserDeposits : 0,
                        })),
                    },
                ];

                setChartData(formattedChartData);
            }
        } catch (error) {
            toast.error("Error loading finance data", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

        } finally {
            setLoading(false);
        }
    };

    const bookTypeLabels = {
        1: "Kindle Edition",
        2: "Paperback",
        3: "Hardcover",
        4: "Audiobook",
        // Добавь сюда другие типы
    };

    const assignmentTypeLabels = {
        1: "Universal Review",
        2: "Kindle Unlimited Review",
        3: "Verified Purchase Review",
        4: "Verified Purchase Review + Photo",
        5: "VF Search & Buy Review",
        6: "VF Search & Buy Review + Photo",
        7: "Amazon Universal for Audio",
        8: "Audible Promo Code Review",
        // Добавь другие типы, если нужно
    };

    const priceLabels = {
        1: "Free Access",
        2: "By for $0.99 USD",
        3: "By for $1.99 USD",
        4: "By for $2.99 USD",
        5: "By for $3.99 USD",
        6: "By for $4.99 USD",
        // Добавь другие категории цен, если нужно
    };
const clearData = () => {
    setFinanceData([]);
    setChartData([]);
    toast.info("Data cleared", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
}

    return (
        <>
        <Row>
            {/* Первая колонка: таблица */}
            <Col md={12}>
                <Card className="shadow-sm bg-light p-1">
                    <Card.Body>
                        <div className="d-flex justify-content-start align-items-center mb-0">

                            <Button variant="success btn-sm" onClick={loadFinanceData} disabled={loading}>
                                {loading ? "Loading..." : "Get Data"}
                            </Button>
                            <Button variant="outline-success btn-sm ms-3" onClick={clearData} disabled={loading}>
                                {loading ? "Loading..." : "Reset"}
                            </Button>
                        </div>

                        {/* Основная таблица */}
                        {financeData.length > 0 && (
                            <div className="mt-3" style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '10px' }}>
                                <Table striped bordered hover size="sm" style={{ minWidth: '1200px' }}>
                                <thead className="small bg-light text-center">
                                <tr className="small">
                                    <th className="text-muted">Date</th>
                                    <th className="text-muted">Users</th>
                                    <th className="text-muted">New/24</th>
                                    <th className="text-muted">Pay</th>
                                    <th className="text-muted">Free</th>
                                    <th className="text-muted">Books</th>
                                    <th className="text-muted">Assign's</th>
                                    <th className="text-muted">NewA</th>
                                    <th className="text-muted">TakeA</th>
                                    <th className="text-muted">DoneA</th>
                                    <th className="text-muted">New/24</th>
                                    <th className="text-muted">Take/24</th>
                                    <th className="text-muted">1</th>
                                    <th className="text-muted">2</th>
                                    <th className="text-muted">3</th>
                                    <th className="text-muted">4</th>
                                    <th className="text-muted">5</th>
                                    <th className="text-muted">6</th>
                                    <th className="text-muted">7</th>
                                    <th className="text-muted">8</th>
                                    <th className="text-muted">Done/24</th>
                                    <th className="text-muted">Total</th>
                                    <th className="text-muted">Balance</th>
                                    <th className="text-muted">Sum Owner</th>
                                    <th className="text-muted">Sum Reader</th>
                                    <th className="text-muted">Utilization</th>
                                    <th className="text-muted">New Reg</th>
                                    <th className="text-muted">Sp/24</th>
                                    <th className="text-muted">Bal</th>
                                    <th className="text-muted">Total</th>


                                </tr>
                                </thead>
                                <tbody className="small fst-italic text-muted">
                                {financeData.map((row, index) => (
                                    <tr key={index} className="align-middle small">
                                        <td className="py-1 px-2 text-center">
                                            {new Date(row?.createdAt).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            }).replace(/ /g, '-')}{' '}
                                            {new Date(row?.createdAt).toLocaleTimeString('en-GB', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false  // 24-часовой формат, если нужно
                                            })}
                                        </td>

                                        <td className="py-1 px-2 text-center">{row?.users}</td>
                                        <td className="py-1 px-2 text-center">{row?.new_reg_users_count_period}</td>
                                        <td className="py-1 px-2 text-center">{row?.pay_users}</td>
                                        <td className="py-1 px-2 text-center">{row?.free_users}</td>
                                        <td className="py-1 px-2 text-center">{row?.books}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_new}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_completed}</td>

                                        <td className="py-1 px-2 text-center">{row?.assignments_new24}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type1}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type2}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type3}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type4}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type5}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type6}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type7}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_in_progress24_type8}</td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_completed24}</td>
                                        <td className="py-1 px-2 text-center">{row?.virt_sum?.toLocaleString('en-US').replace(/,/g, ' ')} </td>
                                        <td className="py-1 px-2 text-center">{row?.users_balance_sum?.toLocaleString('en-US').replace(/,/g, ' ')} </td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_sum_owner?.toLocaleString('en-US').replace(/,/g, ' ')} </td>
                                        <td className="py-1 px-2 text-center">{row?.assignments_sum_reviewer?.toLocaleString('en-US').replace(/,/g, ' ') || '0'} </td>
                                         <td className="py-1 px-2 text-center">{row?.utilized_sum_period?.toLocaleString('en-US').replace(/,/g, ' ') || '0'} </td>
                                        <td className="py-1 px-2 text-center">{row?.new_reg_sum_period ? row?.new_reg_sum_period?.toLocaleString('en-US').replace(/,/g, ' ') : "0"}</td>
                                        <td className="py-1 px-2 text-center">${row?.money_spend_sum_period}</td>
                                        <td className="py-1 px-2 text-center">${row?.money_users_balance_sum}</td>
                                        <td className="py-1 px-2 text-center">${row?.money_sum}</td>

                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                            </div>

                        )}

                    </Card.Body>
                </Card>
            </Col>


        </Row>

</>


);
};

export default AdminFinanceTable;
